import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Breakpoints } from './types';
import { updateBreakpoints } from './redux-slice';
export var BreakpointObserver = function () {
    var dispatch = useDispatch();
    useEffect(function () {
        var updateBreakpointValues = function () {
            var width = window.innerWidth;
            dispatch(updateBreakpoints({
                isMobileOrSmaller: width < Breakpoints.TABLET,
                isTabletOrSmaller: width < Breakpoints.LAPTOP,
                isLaptopOrSmaller: width < Breakpoints.DESKTOP,
                currentWidth: width,
            }));
        };
        updateBreakpointValues();
        window.addEventListener('resize', updateBreakpointValues);
        return function () { return window.removeEventListener('resize', updateBreakpointValues); };
    }, [dispatch]);
    return null;
};
